<div class="mx-auto mt-2 w-full md:w-4/5">
  <yr-create-profile-hint></yr-create-profile-hint>
</div>
